import script from "./MenuItemImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItemImage.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItemImage.vue?vue&type=style&index=0&id=7ed66ca6&lang=scss"

const __exports__ = script;

export default __exports__